export function isDOMElement(Component: React.ReactElement) {
  return typeof Component.type === 'string'
}
